import React, { useState, useEffect } from "react";
import { FaRocket, FaTags, FaFire } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch blogs on component mount
  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_blog_seller"
      );

      if (response.data.status === true) {
        setBlogs(response.data.data || []);
        setError(null);
      } else {
        setError(response.data.message || "Failed to fetch blogs");
      }
    } catch (err) {
      console.error("Error fetching blogs:", err);
      setError("Failed to load blogs. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  // Get full image URL
  const getImageUrl = (imagePath) => {
    return `https://cyberathon.com/multivendor/${imagePath}`;
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              {/* <h4 className="mb-0 fw-semibold">Dashboard</h4> */}
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Venton</a>
                </li>
                <li className="breadcrumb-item active">Blogs</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        {/* Start here.... */}
        <div className="row">
          <div className="container mb-4">
            {/* Page Title */}
            <div>
              <h3 className="fw-bold">Blog Section</h3>
              <p className="text-muted">
                Promote your products and increase sales using marketing tools
              </p>
              <div className="text-end mb-2">
                <button className="btn btn-primary">Add Blog</button>
              </div>
            </div>

            {/* Loading State */}
            {loading && (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2 text-muted">Loading blogs...</p>
              </div>
            )}

            {/* Error State */}
            {error && !loading && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            {/* No Blogs State */}
            {!loading && !error && blogs.length === 0 && (
              <div className="text-center py-5">
                <p className="text-muted">No blogs available at the moment.</p>
                <button className="btn btn-primary mt-2">Create Your First Blog</button>
              </div>
            )}

            {/* Blogs Grid */}
            {!loading && !error && blogs.length > 0 && (
              <div className="row g-4">
                {blogs.map((blog) => (
                  <div className="col-md-4" key={blog.blog_id}>
                    <div className="card shadow-sm h-100 border-0">
                      <div className="card-body text-center">
                        <img
                          src={getImageUrl(blog.image)}
                          alt="Blog"
                          style={{ width: "300px", objectFit: "cover" }}
                          onError={(e) => {
                            e.target.src = "/images/product/p-1.png";
                          }}
                        />
                        <div className="text-start mt-2">
                          <p className="text-muted mb-1">
                            {formatDate(blog.created_at)}
                          </p>
                        </div>
                        <p className="card-text text-muted">
                          {blog.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />
              <a href="" className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default Blogs;

export const Addblog = () => {
  const navigate = useNavigate();
  
  const initialFormState = {
    description: "",
  };

  const [blogData, setBlogData] = useState(initialFormState);
  const [blogImage, setBlogImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setBlogData({ ...blogData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setBlogImage(file);
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
    } else {
      setPreviewImage(null);
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!blogData.description?.trim()) {
      toast.error("Please enter blog description");
      return;
    }

    if (!blogImage) {
      toast.error("Please select an image");
      return;
    }

    const formData = new FormData();
    
    // Append description
    formData.append("description", blogData.description.trim());
    
    // Append image
    formData.append("image", blogImage);

    try {
      setIsSubmitting(true);
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_blog_seller",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Check if API returns success
      if (response.data && response.data.status === true) {
        toast.success(response.data.message || "Blog added successfully!");
        
        // Reset form
        setBlogData(initialFormState);
        setBlogImage(null);
        setPreviewImage(null);
        
        // Navigate to blogs list after short delay
        setTimeout(() => {
          navigate("/blogs");
        }, 1500);
      } else {
        const msg = response.data?.message || "Failed to add blog";
        toast.error(msg);
      }
    } catch (error) {
      console.error("Add blog error:", error);
      toast.error(
        error.response?.data?.message || 
        "Something went wrong while adding blog."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Create Blog</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Blog</a>
                </li>
                <li className="breadcrumb-item active">Create Blog</li>
              </ol>
            </div>
          </div>
        </div>

        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-xl-9 col-lg-8 ">
            <form onSubmit={submitForm} encType="multipart/form-data">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Add Image</h4>
                </div>
                <div className="card-body">
                  <div className="dropzone bg-light-subtle py-5">
                    <label className="form-label text-dark">Image</label>
                    <input
                      type="file"
                      id="blog-image"
                      className="form-control"
                      accept="image/*"
                      onChange={handleImageChange}
                      required
                    />
                    {previewImage && (
                      <div className="mt-3">
                        <img
                          src={previewImage}
                          alt="Preview"
                          className="img-thumbnail"
                          style={{ 
                            width: "200px", 
                            height: "auto",
                            objectFit: "cover" 
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">General Information</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label className="form-label">Blog Description</label>
                        <textarea
                          id="description"
                          name="description"
                          onChange={handleInput}
                          value={blogData.description}
                          className="form-control"
                          placeholder="Enter blog description"
                          rows="5"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3 bg-light mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-2">
                    <button
                      type="submit"
                      className="btn btn-outline-secondary w-100"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save Change"}
                    </button>
                  </div>
                  <div className="col-lg-2">
                    <Link to="/blogs" className="btn btn-primary w-100">
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      
      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to="#" className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
      
      <ToastContainer />
    </div>
  );
};